<template>
	<div class="container">
		<div class="container__contact-list " :class="{ 'shadow': !isScrollAtEnd }">
			<div class="flex justify-between items-center px-[10px] searchbar-wrapper">
				<ion-icon :icon="filters.state == 'UNREAD' ? filterCircle : filterCircleOutline"
					class="container__contact-list__search__icon"
					v-tooltip.top-center="{ content: filters.state == 'UNREAD' ? $t( 'Zobraziť všetky' ) : $t( 'Zobraziť neprečítané' ), theme: 'info-tooltip' }"
					@click="filters.state == 'UNREAD' ? filters.state = null : filters.state = 'UNREAD'" />
				<Mdx-searchbar ref="searchbar" class="container__contact-list__search" size="small" v-model="filters.search"
					:debounce="300" />
			</div>

			<div class="container__contact-list__scrollable-list "  ref="scrollableList" @scroll="checkScroll">
				<template v-if="!sortedPatients || sortedPatients.length">
					<div v-for="(patient, index) in $skelet( sortedPatients, 5 )" :key="index" class="patient"

					:class="{ 'is-active': selectedPatientId == patient?.patient_id }"
					@click="closeSidemenu(), selectPatient( patient )">
					<span class="patient__unread" v-if="patient && !patient.is_readed" v-tooltip.top-center="{content:  $t('Neprečítaná správa'), theme: 'info-tooltip',  delay: { show: 100, hide: 500 }}"></span>

						<p class="patient__left">
							<span class="detail" v-if="patient">{{formatName(patient.first_name) }} {{ formatName(patient.last_name) }}</span>
						<div v-else class="skelet w-[150px] h-[14px] mb-[6px]"></div>

						<span class="detail" v-if="patient">{{ patient.personal_id }}</span>
						<div v-else class="skelet w-[100px] h-[14px] mb-[6px]"></div>
						</p>

						<div v-if="patient?.last_result_date" class="patient__right">
							<p class="detail">{{ formatTimeMenu( patient.last_result_date ) }}</p>
						</div>
					</div>

					<div v-if="sortedPatients" v-tooltip.top-center="{ content: loadMoreTooltip, theme: 'info-tooltip' }" class="load-patient" :class="{'cursor-not-allowed': !!loadMoreTooltip}">
						<Z-icon-button :loading="loading" :disabled="!!loadMoreTooltip" @click="loadMore">{{ $t('Načítať viac') }}</Z-icon-button>
					</div>
				</template>

				<template v-else>
					<p class="px-[15px] py-[10px]">{{ $t( 'Hľadaniu nevyhovujú žiadne výsledky' ) }}</p>
				</template>
			</div>
			<Z-hint slug="results" class="hint fixed"></Z-hint>
		</div>

	</div>
</template>

<script>
import ZHint from '@/plugins/app@components/hint/z-hint.vue'
import { formatTimeMenu } from '@/plugins/app/utils/date.utils'
import { checkmark, almost, close } from '@/plugins/@medirex/icons'
import { filterCircle, filterCircleOutline } from 'ionicons/icons'

export default {
	emits: ['select-patient', 'close-sidemenu', "next-page"],
	components: { ZHint },

	props: {
		modelValue: {
			type: [Object, null],
			default: () => null
		},
		selectedPatientId: {
			type: [Number, String, null],
			required: true
		},
		patients: {
			type: [Object, null],
			required: true
		},
		pagination: {
			type: [Object, null],
		},
		loading: {
			type: Boolean,
			default: false
		}
	},

	data() {
		return {
			filterCircleOutline,
			filterCircle,
			formatTimeMenu,
			isScrollAtEnd: true
		}
	},

	computed: {
		filters: {
			get() {
				return this.modelValue
			},
			set(value) {
				this.$emit('update:modelValue', value)
			}
		},

		sortedPatients() {
			if (!this.patients) return null

			return Object.values(this.patients).sort((a, b) => {
				return new Date(b.last_result_date) - new Date(a.last_result_date)
			})
		},

		loadMoreTooltip() {
			return this.pagination?.current_page == this.pagination?.last_page ? this.$t('Všetky výsledky boli zobrazené') : null
		}
	},

	async mounted() {
		window.addEventListener("keydown", this.handleKeyPress),
		this.checkScroll();
	},

	beforeDestroy() {
		window.removeEventListener("keydown", this.handleKeyPress)
	},

	methods: {
		async loadMore() {
			await this.$emit('next-page')
			this.checkScroll()
		},

		checkScroll() {
			const scrollableList = this.$refs.scrollableList;
			this.isScrollAtEnd = scrollableList.scrollTop + scrollableList.clientHeight >= scrollableList.scrollHeight;
		},

		focusSearchBar() {
			this.$refs.searchbar.$el.setFocus()
		},

		handleKeyPress(event) {
			if ((event.ctrlKey || event.metaKey) && event.key === "k") {
				event.preventDefault()
				this.focusSearchBar()
			}
		},

		selectPatient(patient) {
			this.$emit('select-patient', patient.patient_id)
		},

		closeSidemenu() {
			this.$emit('close-sidemenu')
		},

		formatName(str) {
			if (!str) {
				return '';
			}
			//retunr sting with replaced _ with space
			return str.replace(/_/g, ' ');
		},

		// R: Toto neskor upravime
		iconCheck(status) {
			if (status === "Akceptovaná" || status === "Odoslaná" || status === "Vyšetrená") {
				return checkmark
			} else if (status === "Čiastočne vyšetrená") {
				return almost
			} else if (status === "Nevyšetrená") {
				return close
			}
			return null
		},
	},

	watch: {
		patients: {
			handler() {
				this.checkScroll();
			},
			deep: true
		}
	}
}
</script>

<style lang="sass" scoped>
@import '@/plugins/app/theme/_mixins/responsive.mixin'
.unread
	width: 8px
	height: 8px
	border-radius: 50%
	background-color: var(--ion-color-primary)
	position: absolute
	left: 10px
	top: 30%
	transform: translateY(-50%)


.shadow
	box-shadow: inset 0 -60px 60px -60px rgba(0, 0, 0, 0.6)
.container
	@apply bg-[#FFF] ml-[65px] mr-[10px] w-[320px]

	+xl
		@apply w-auto mt-[20px] mx-[16px]

	&__contact-list
		@apply w-full m-auto

		&__search
			@apply w-[290px] my-[10px]

			+xl
				@apply w-auto mx-0 mt-0

			&__icon
				@apply text-[28px] mr-[10px] text-[--ion-color-primary] cursor-pointer

		&__scrollable-list
			@apply flex flex-col h-[65vh] overflow-y-scroll relative

			&:last-child
				border-bottom: none

			&::-webkit-scrollbar
				-webkit-appearance: none
				width: 5px

			&::-webkit-scrollbar-track
				border-radius: 4px
				background: transparent
				background-color: rgba(0, 0, 0, .1)
				box-shadow: 0 0 1px rgba(255, 255, 255, .5)

			&::-webkit-scrollbar-thumb
				background: var(--ion-color-medium)

			&::-webkit-scrollbar-thumb:hover
				background: var(--ion-color-medium-shade)

			@media only screen and (max-height: 700px)
				@apply h-[55vh]

			@media only screen and (max-height: 550px)
				@apply h-[45vh]

.load-patient
	@apply flex items-center justify-center py-5

	:deep(.spinner)
		left: 50%!important

.searchbar-wrapper
	border-bottom: 1px solid #E6EBF0

.patient
	display: flex
	position: relative
	justify-content: space-between
	align-items: center
	padding: 10px
	padding-left: 27px
	border-bottom: 1px solid #E6EBF0
	cursor: pointer

	+xl
		@apply pr-[27px]

	&:hover
		background-color: var(--ion-color-primary-tint)
		color: var(--ion-color-primary-contrast)
		.patient__unread
			background-color: var(--ion-color-primary-contrast)
		.detail
			color: var(--ion-color-primary-contrast)


	&.is-active
		background-color: var(--ion-color-primary)
		color: var(--ion-color-primary-contrast)
		.patient__unread
			background-color: var(--ion-color-primary-contrast)
		.detail
			color: var(--ion-color-primary-contrast)

	&__unread
		width: 8px
		height: 8px
		border-radius: 50%
		background-color: var(--ion-color-primary)
		position: absolute
		left: 10px
		top: 30%
		transform: translateY(-50%)

	&__left
		span
			@apply block font-normal text-sm leading-[20px]


	&__right
		@apply flex items-center mb-auto mt-[1px] text-sm

		+sm
			@apply flex flex-col-reverse items-end

		&__status
			@apply mr-[12px] mt-[-3px]

			+sm
				@apply mr-0 mt-1

</style>